{
  "staff-selection-dialog": {
    "buttons": {
      "close": "Close",
      "select": "Select",
      "selected": "Selected"
    },
    "text": {
      "title": "Staff selection",
      "first-available": "First available staff"
    }
  }
}
